import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postData } from "../../Service/ApiMethod";
import { SEND_OTP, VERIFY_OTP } from "../../Service/service";
import OTPInput from "react-otp-input";
import PhoneInput from "react-phone-input-2";
import Geocode from "react-geocode";
import { useContext } from "react";
// import { candata } from "../../App"; 
import Loader from "./Loader";
import { allTimeZone } from "./Countrycode";
import { lang } from "../../lang";


const Otp = () => {

  // Geocode.setApiKey("AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk");
  // const {newData, setNewData} = useContext(candata)
  const [ln,setLn] = useState('en')
  // const [verifyButtonDisable, setVerifyButtonDisable] = useState(true);
  // const [otp1, setOtp1] = useState("");
  // const [otp2, setOtp2] = useState("");
  // const [otp3, setOtp3] = useState("");
  // const [otp4, setOtp4] = useState("");
  // const [otp5, setOtp5] = useState("");
  // const [otp6, setOtp6] = useState("");
  const [error, setError] = useState();
  const [resendSeconds, setResendSeconds] = useState(0);


  const [sendOtp, setSendOtp] = useState(false);

  const sendRef1 =  useRef  (null) 
  // const sendRef2 =  useRef  (null) 
  // const sendRef3 =  useRef  (null) 
  // const sendRef4 =  useRef  (null) 
  // const sendRef5 =  useRef  (null) 
  // const sendRef6 =  useRef  (null) 
  
  const [selectedRef, setSelectedRef]=useState(sendRef1)
  const [OTP, setOTP] = useState("");
  const [countryCodes, setCountryCode] = useState('')
  const [checkNumber,setChecknumber] = useState("")
function handleChange(OTP) {
  setOTP(OTP);
  
}




const countryCode = useRef(null)
const [countryCod, setCountrycod] = useState('fi')
  useEffect(() => {
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
    locations()
  })

  const locations = async () => {
    if (navigator?.geolocation) {
      await navigator?.geolocation?.getCurrentPosition(function (position) {
        console.log("Latitude is :", position?.coords?.latitude);
        console.log("Longitude is :", position?.coords?.longitude);

       
        localStorage.setItem('lat', position?.coords?.latitude);
        localStorage.setItem('lng', position?.coords?.longitude);
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const reverseGeocodingUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk`;

        // call Reverse Geocoding API - https://www.geoapify.com/reverse-geocoding-api/
        fetch(reverseGeocodingUrl)
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 'OK') {
              var address = data.results[0].address_components;
              const countryComponent = data.results[0].address_components.find(
                component => component.types.includes('country')
              );

              if (countryComponent) {
                const countryShortCode = countryComponent.short_name;
                console.log(countryShortCode, "ssssss"); // Display the country short code
                allTimeZone.map((item) => {
                  if (item.Code == countryShortCode) {
                    console.log(item.Code.toLowerCase(), "onnnnnnnn000000",countryCode.current);
                    countryCode.current = item.Code.toLowerCase()
                    setCountrycod(item.Code.toLowerCase())
                  }
                })
              }

              // Do something with the address
              console.log(address, "0000000000000000000000000000000000000000000000");
            } else {
              // Handle the error case
              // console.log('Error: ' + data.status);
            }
          })
          .catch((error) => {
            // console.log('Error: ' + error.message);
          });

      }, function (error) {
        console.log(error);
      });

    } else {
      console.log('error in locating')
    }

  }









  //   const [sendOtp, setSendOtp] = useState(false);
  const [phone, setPhone] = useState("");

  const navigate = useNavigate();


  const handleLogin = () => {
    setOTP("")
    setLoaderstart(true)
    if (!phone) {
      alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.LoginPassword['Please Enter Your Mobile Number']:"")
      setLoaderstart(false)
    }
 else if(resendSeconds === 0 ){
  let objItem = {
    user_types: "recruiter",
    phone: checkNumber.charAt(0) === '0' ? "+"+countryCodes+ checkNumber.slice(1) :"+"+countryCodes+ checkNumber,
  };
  console.log("static", objItem);

  postData(objItem, SEND_OTP)
    .then((response) => response.json())
    .then((data) => {
      setLoaderstart(false)
      console.log(data);
      if (data.status_code == 200) {
        setSendOtp(true);
        alert(data.message);
      }else{
        alert(data?.error_message)
      }
    })
    .catch((err) => {
      setLoaderstart(false)
      console.log("Error in categories from Post Form", err);
      console.log(" code Error", err);
      
    });

    
    setResendSeconds(30);
  const intervalId = setInterval(() => {
    setResendSeconds(prevSeconds => prevSeconds - 1);
  }, 1000);

  // Stop the timer after 30 seconds
  setTimeout(() => {
    clearInterval(intervalId);
    setResendSeconds(0);
  }, 30000);


}
else{

}
  
  };




  // Geocode.setApiKey("AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk");

  const currentLocation = async () => {

    if (navigator?.geolocation) {
      await navigator?.geolocation?.getCurrentPosition(function (position) {
        console.log("Latitude is :", position?.coords?.latitude);
        console.log("Longitude is :", position?.coords?.longitude);

        // setLatitude(position?.coords?.latitude);
        // setLongitude(position?.coords?.longitude);
        localStorage.setItem('lat', position?.coords?.latitude);
        localStorage.setItem('lng', position?.coords?.longitude);
      }, function (error) {
        console.log(error);
      });

    } else {
      console.log('error in locating')
    }

  };


  const navigateToSuccess = () => {

    currentLocation()

    setTimeout(() => {
      navigate('/map')
    }, 1000)

  };

  const verifyOtp = async () => {
    setLoaderstart(true)
    console.log("verify otp fn");
    // const fullOtp = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;
    const fullOtp = OTP;
    const obj = {
      phone:  checkNumber.charAt(0) === '0' ? "+"+countryCodes+ checkNumber.slice(1) :"+"+countryCodes+ checkNumber,
      otp: fullOtp,
      user_types: "recruiter",
    };

  await postData(obj, VERIFY_OTP)
  .then((res) => res.json())
  .then((data) => {
    setLoaderstart(false)
    console.log('verify otp response', data);
    try {
      console.log("From Api", data)
      const token = data?.data?.access;
      console.log('token', token)
      localStorage.setItem(
        "catzapp_token",
        token,
        "login_Phone",
        data?.data?.user?.phone
      );
      if (token !== undefined) {
          navigateToSuccess();
          // setNewData(!newData)
         if (!localStorage.getItem('alertShown')) {
          alert(data?.message);
          localStorage.setItem('alertShown', true);
        }

      } else {
        alert((data?.error_message?.otp) != undefined ? data?.error_message?.otp : data?.error_message);
      }
    } catch (err) {
      setLoaderstart(false)
      console.log("error hgappended", err);
      setError(err.message, " already exists");
      // alert("Error", err);
    }
   
  });



};
  //   await postData(obj, VERIFY_OTP)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       console.log(data);
  //       if (data.status_code == 200) {
  //         localStorage.setItem("catzapp_token", data.access);
  //         // navigate("/home")
  //         alert(data.message)
  //         navigate('/home')
  //       }else{
  //       alert('Incorrect OTP')
  //       }
  //     })
  // };

// useEffect(()=>{
//   selectedRef.current?.focus()
// },[selectedRef]
// )

console.log("otpppp" , OTP);
  
const [loaderStart, setLoaderstart] = useState(false)
    

  return (
    <>
     

     {
    loaderStart == true ? (<Loader/>):null
   }

      <div className=""  >
        {sendOtp ? (
<>


          <div style={{textAlign:'center'}}>  <img src="./images/otp.png" alt="" className="login-img" />
          <p className="text text-center">
          {lang && Object.keys(lang).length > 0 ? lang[ln]?.interOtp["we have sent an OTP to"]:""} +{phone}
          </p> </div>
          <OTPInput  inputStyle={{width:'87%', fontSize:'15px'}}
          onChange={handleChange}
          className="mobile_four_digit_verification_code flex-center justify-content-between my-3 "
              // name="ssn-3"
          value={OTP}
          isInputNum ="number"
          id="OTP"
          numInputs={6}
          separator={<span></span>}
          
        />
</>
        
       


        ) : (
          <div className="input-container my-2">
          
          <div style={{ textAlign: "center" }}>  
            <img src="./images/otp.png" alt="" className="login-img" /> 
          <p className="text text-cente my-2">
            {lang && Object.keys(lang).length > 0 ? lang[ln]?.forgetPassword["Please enter your mobile number to generate OTP"]:""}
          </p> </div>
            <div>
          <PhoneInput inputStyle={{width:'100%', fontSize:'21px',  border:'0.5px solid gray' , zIndex:"9999999999"}}
          inputClassName='reactphoneinput'
          placeholder="Enter Mobile Number"
          type='text'
          country={countryCod}
          enableSearch={true}
          // defaultValue='+91'
          onChange={(phone, selectedCountry) => {
            const phoneNumberWithoutCode = phone.replace(selectedCountry.dialCode, '');
            console.log(phoneNumberWithoutCode,"ow")
            setChecknumber(phoneNumberWithoutCode)
            setPhone(phone)
            setCountryCode(selectedCountry.dialCode)
          }}
          name=''
          id='phone'
          />
            {/* <img src="./images/call.png"  alt="" className="left-img " /> */}
          </div>
      </div>

        )}
      </div>

{/* <div className="otp">
          <OTPInput
            onChange={handleChange}
            value={OTP}
            inputStyle="inputStyle"
            numInputs={6}
            separator={<span></span>}
          />
        </div> */}

      {sendOtp ? (
        <button className="theme-btn" onClick={() =>{
          verifyOtp();
          // navigate("/home")
        } }>
           {lang && Object.keys(lang).length > 0 ? lang[ln]?.ResetPassword["Submit OTP"]:""}
          
        </button>
      ) : (
        <button
          className="theme-btn"
          onClick={() => {
            handleLogin();
          }}
        >
          {lang && Object.keys(lang).length > 0 ? lang[ln]?.forgetPassword["Send OTP"]:""}
          
        </button>
      )}

      {sendOtp ? (
        // <p className="text-center text mt-2">
        //   Didnt Recieve Code yet? <button className="resend" onClick={handleLogin}>Resend OTP</button>
        // </p>
        <div className="text-center text mt-2 " style={{display:'flex' , justifyContent:'center' ,alignItems:'center' }}>
          {lang && Object.keys(lang).length > 0 ? lang[ln]?.interOtp["Did Not Receive Code Yet?"]:""} {!resendSeconds &&  <button className="resend" onClick={handleLogin}> {lang && Object.keys(lang).length > 0 ? lang[ln]?.interOtp["Resend OTP"]:""}</button>}{resendSeconds > 0 && <div  className=" resend mx-2">00:{resendSeconds} sec</div>}
          
        </div>
      ) : null}
    </>
  );
};


export default Otp;
